import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import { TextFieldInput, TextFieldOutput } from '@trackback/widgets';
import { takeUntil } from 'rxjs/operators';
import { BaseFormControlWidgetComponent } from '../base-form-control-widget.component';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';

@Register('TextField')
@Component({
  selector: 'tb-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    AsyncPipe,
    ParsePipe,
  ],
})
export class TextFieldComponent
  extends BaseFormControlWidgetComponent<TextFieldInput, TextFieldOutput>
  implements OnInit
{
  hide: boolean;
  actionDisabled: boolean;

  /**
   * @see {@link https://ux.stackexchange.com/questions/95336/how-long-should-the-debounce-timeout-be}
   */
  defaultDebounceTime() {
    return 500;
  }
  async ngOnInit() {
    await super.ngOnInit();
    this.hide = this.input.fieldType === 'password';
    if (this.input.actionDisabled) {
      this.parse(this.input.actionDisabled)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(actionDisabled => (this.actionDisabled = !!actionDisabled));
    } else {
      this.actionDisabled = false;
    }
  }

  onEnter() {
    if (!this.actionDisabled && this.input.enterAction) {
      this.updateOutput({ actionPending: true }, false);
      this.dispatchActionsPromise(this.input.enterAction).finally(() =>
        this.updateOutput({ actionPending: false }, false)
      );
    }
  }
}
